import React from 'react';
import styles from '../StructuredModal.module.scss';
import { SproutButton } from 'components/Button/SproutButton';
import { ButtonVariant } from '@clover-web-lib-sprout/button';

export interface StructuredModalAction {
  label: string;
  variant: ButtonVariant;

  action?: () => boolean | void;
  isCloseButton?: boolean;
}

export const ModalActions: React.FC<{
  actions?: StructuredModalAction[];
  handleAction: (modalAction: StructuredModalAction) => void;
}> = ({ actions = [], handleAction }) => {
  if (actions.length === 0) return null;

  return (
    <div className={styles.modalActions}>
      {actions?.map(action => (
        <SproutButton key={action.label} variant={action.variant} onClick={() => handleAction(action)}>
          {action.label}
        </SproutButton>
      ))}
    </div>
  );
};
